/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar, Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/
import { combineReducers } from "redux";
import GlobalReducer from "./global-reducer";
import patientReducer from "./patient-reducer";
import userReducer from "./user-reducer";
import bulkUploadImageReducer from "./bulk-upload-reducer";
import viewImagesReducer from "./view-images-reducer";
import viewPatientReducer from "./view-patient";
import viewPatientBuReducer from "./view-patient-bu";

import importjsonreducer from "./import-json-reducer";
import reviewPatientReducer from "./review-patient-reducer";
import reviewImagesReducer from "./review-images-reducer";
import doctorAnnotationPatientReducer from "./doctor-annotation-patient-reducer";
import entitlementReducer from "./entitlement-reducer";
const rootReducer = combineReducers({
  globalStore: GlobalReducer,
  patientStore: patientReducer,
  userStore: userReducer,
  bulkUploadImageStore: bulkUploadImageReducer,
  viewImagesStore: viewImagesReducer,
  reviewImagesStore: reviewImagesReducer,
  viewPatientStore: viewPatientReducer,
  viewPatientBuStore: viewPatientBuReducer,

  // patientsInBulkuploadFromJson: importjsonreducer,
  reviewPatientStore: reviewPatientReducer,
  doctorAnnotationPatientStore: doctorAnnotationPatientReducer,
  entitlementStore: entitlementReducer,
});
export default rootReducer;

doctorAnnotationPatientReducer;
